<script setup>
import { computed } from 'vue';
import { ICONS } from './icons';

// Renders a Lucide icon by its kebab-case name (matching the design system's
// `data-lucide="paw-print"` convention). Resolves against the explicit registry
// in icons.js so only the icons we use are bundled.
const props = defineProps({
  name: { type: String, required: true },
  size: { type: [Number, String], default: 24 },
  strokeWidth: { type: [Number, String], default: 2 },
});

const component = computed(() => ICONS[props.name] || null);
</script>

<template>
  <component
    :is="component"
    v-if="component"
    :size="Number(size)"
    :stroke-width="Number(strokeWidth)"
    aria-hidden="true"
  />
</template>
